export interface LayoutOption {
    type: string;
    allowedOrientations: string[];
    allowedPageTypes: string[];
}

export const layoutOptions: LayoutOption[] = [
    {
        type: '3x2',
        allowedOrientations: ['portrait'],
        allowedPageTypes: ['a4'],
    },
    {
        type: '2x2+t',
        allowedOrientations: ['portrait'],
        allowedPageTypes: ['a4'],
    },
    {
        type: '2x2',
        allowedOrientations: ['portrait', 'landscape'],
        allowedPageTypes: ['a4'],
    },
    {
        type: '2x1',
        allowedOrientations: ['portrait'],
        allowedPageTypes: ['a4', 'a5'],
    },
    {
        type: '1x2', // WARNING: The old format used this label for 2x1 portrait a4
        allowedOrientations: ['landscape'],
        allowedPageTypes: ['a5'],
    },
    {
        type: '1x2+t',
        allowedOrientations: ['landscape'],
        allowedPageTypes: ['a5'],
    },
    {
        type: '1x1+t',
        allowedOrientations: ['portrait'],
        allowedPageTypes: ['a4'],
    },
    {
        type: '1x1+t',
        allowedOrientations: ['landscape'],
        allowedPageTypes: ['a5'],
    },
    {
        type: 't',
        allowedOrientations: ['portrait', 'landscape'],
        allowedPageTypes: ['a4', 'a5'],
    },
    {
        type: '1x3+t',
        allowedOrientations: ['landscape'],
        allowedPageTypes: ['a4'],
    },
    {
        type: '1x1',
        allowedOrientations: ['landscape'],
        allowedPageTypes: ['a4', 'a5'],
    },
    {
        type: '2x3',
        allowedOrientations: ['landscape'],
        allowedPageTypes: ['a4'],
    },
];

interface LayoutMapping {
    rows: number;
    columns: number;
    text: boolean;
}

export const layoutMappings: { [key: string]: LayoutMapping } = {
    '3x2': {
        rows: 3,
        columns: 2,
        text: false,
    },
    '2x2+t': {
        rows: 2,
        columns: 2,
        text: true,
    },
    '2x2': {
        rows: 2,
        columns: 2,
        text: false,
    },
    '2x1': {
        rows: 2,
        columns: 1,
        text: false,
    },
    '1x2': {
        rows: 1,
        columns: 2,
        text: false,
    },
    '1x2+t': {
        rows: 1,
        columns: 2,
        text: true,
    },
    '1x1+t': {
        rows: 1,
        columns: 1,
        text: true,
    },
    t: {
        rows: 0,
        columns: 0,
        text: true,
    },
    '1x3+t': {
        rows: 1,
        columns: 3,
        text: true,
    },
    '1x1': {
        rows: 1,
        columns: 1,
        text: false,
    },
    '2x3': {
        rows: 2,
        columns: 3,
        text: false,
    },
};
